import "./receipt.css";

import { type ReactNode } from "react";
import { useTenantBranding } from "@/hooks/useTenantBranding";
import { combineReceiptSubTitle } from "./TenantTrustSubTitle";

export type ReceiptHeaderProps = {
  /** Defaults to `tenants.name` from `GET /tenant-branding/me` (exact value). */
  title?: ReactNode;
  /** Appended below trust name and registration from the tenant record. */
  subTitle?: ReactNode;
  /** When false, omit trust name / registration lines. Defaults to true. */
  showTenantTrust?: boolean;
};

const ReceiptHeader = ({ title, subTitle, showTenantTrust = true }: ReceiptHeaderProps) => {
  const { tenantName, trustName, trustId, logoUrl } = useTenantBranding();
  const displayTitle = title ?? tenantName;
  const displaySubTitle = showTenantTrust
    ? combineReceiptSubTitle(trustName, trustId, subTitle)
    : subTitle;

  return (
    <>
      <div className="u-row" style={{ margin: "0 auto", display: "flex" }}>
        <div className="u-col u-col-21p13">
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={tenantName ? `${tenantName} logo` : "Logo"}
              style={{ height: "auto", width: "100%", maxWidth: "110px" }}
              width={50}
            />
          ) : null}
        </div>

        <div
          className="u-col u-col-78p87"
          style={{
            textAlign: "left",
            wordWrap: "break-word",
            padding: "10px 0",
            alignSelf: "center",
          }}
        >
          <h1 style={{ margin: "0", fontSize: "22px", lineHeight: "22px", fontWeight: "700" }}>
            {displayTitle}
          </h1>

          {displaySubTitle ? (
            <h2
              style={{ marginTop: "5px", fontSize: "16px", lineHeight: "16px", fontWeight: "400" }}
            >
              {displaySubTitle}
            </h2>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default ReceiptHeader;
